export const PRODUCT = {
  brand: 'Sweeth',
  eyebrow: 'SWEETH',
  name: 'ClearShape',
  reference: 'PSCS12',
  subtitle:
    'Resin for direct-printed transparent dental appliances (1 kg bottle)',
  shortName: 'ClearShape (1 kg)',
  fullName: 'Sweeth ClearShape',
  description:
    'A dental 3D-printing resin for direct-printed aligners, retainers and splints, with a heat-activated shape-memory response and 60% elongation at break. Supplied in 1 kg bottles; TDS, SDS and IFU available upon request.',
  imageSrc: '/images/clearshape.jpg',
  imageAlt: 'Sweeth ClearShape resin, 1 kg bottle',
  inStock: true,
  deviceNotice:
    'Sweeth ClearShape is a CE-marked medical device (EU MDR) supplied for professional dental use only.',
} as const;

export const SPECIFICATIONS = [
  { key: 'Net weight', value: '1 kg' },
  { key: 'Reference', value: 'PSCS12' },
  { key: 'Indications', value: 'Aligners, retainers, splints' },
  { key: 'Classification', value: 'CE-marked, EU MDR' },
  { key: 'Tg (heat activation)', value: '45 °C' },
  { key: 'Flexural strength', value: '40 MPa' },
  { key: 'Flexural modulus', value: '980 MPa' },
  { key: 'Tensile strength', value: '30 MPa' },
  { key: 'Elongation at break', value: '60%' },
  { key: 'Storage', value: 'Protected from sunlight' },
] as const;
